export class CategoryTreeNode {
	data: number = null;
	label: string = null;
	Category: string = undefined;
	SubCategory: string = undefined;
	RecipeGroup: string = undefined;
	children: CategoryTreeNode[] = [];
	parent: CategoryTreeNode;
	nodeType: NodeType = 0;
	IsSelected = false;
	expanded = false;
}

export enum NodeType {
	NoType = 0,
	Category = 1,
	SubCategory = 2,
	RecipeGroup = 3
}



// WEBPACK FOOTER //
// ./src/app/shared/models/category-tree-model.ts